<template>
  <el-dialog
    title="Восстановление пароля"
    :visible.sync="modalIsVisible"
    v-on:close="closeModal"
    width="500px"
    :fullscreen="$mq === 'xs'"
  >
    <el-result class="result" v-if="messageSent" icon="success" title="Мы отправили сообщение на ваш email." subTitle="Если оно не пришло, запросите повторную отправку. Если этот способ не помогает, обратитесь в техподдержку.">
      <template slot="extra">
        <el-button type="primary" @click.prevent="submit" size="medium" :disabled="timerCount > 0" >Отправить повторно {{timerCount ? '(' + timerCount + ')' : ''}}</el-button>
      </template>
    </el-result>
    <div v-else>
      <p>Мы отправим вам сообщение с инструкциями по восстановлению пароля на привязанный к аккаунту email.</p>
      <el-form :model="form" ref="form">
        <el-form-item :error="getFieldError()">
          <el-input
            name="full_search"
            placeholder="Логин или email"
            v-model="form.full_search"
            v-validate="'required'"
          />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer" v-if="!messageSent">
      <el-button @click="closeModal">{{$t('Cancel')}}</el-button>
      <el-button type="primary" :loading="loading" @click.prevent="submit">Продолжить</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Dialog, Button, Form, FormItem, Input, Result } from 'element-ui'
import axios from 'axios'

export default {
  name: 'restore-password-modal',
  components: {
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [Input.name]: Input,
    [FormItem.name]: FormItem,
    [Result.name]: Result
  },
  props: ['modalIsVisible'],
  data () {
    return {
      form: {
        full_search: ''
      },
      timerCount: null,
      loading: false,
      messageSent: false
    }
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
          }, 1000)
        }
      }
      // immediate: true // This ensures the watcher is triggered upon creation
    }
  },
  methods: {
    closeModal () {
      this.form.full_search = ''
      this.errors.clear()
      this.messageSent = false
      this.timerCount = null
      this.$emit('closeModal')
    },
    submit () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.loading = true
            axios.post('profile/recoverPassword', {
              'full_search': this.form.full_search
            }).then(promise => {
              this.loading = false
              this.messageSent = true
              this.timerCount = 120
            }).catch(() => {
              this.loading = false
              this.$notify(
                {
                  message: this.$t('Что-то пошло не так'),
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                }
              )
            })
          }
        })
    },
    getFieldError () {
      console.log('errors: ', this.errors)
      return this.$t(this.errors.first('full_search'))
    }
  }
}

</script>

<style>
.result {
  text-align: center
}
.result .el-result__icon {
  margin-bottom: 8px;
}
.result .el-result__icon svg {
    width: 64px;
    height: 64px;
}
.result .icon-success {
    fill: #67c23a;
}
</style>
